module.exports = __webpack_public_path__ + "media/images/svg/arrow-5bf287adf9c57e4c02c948db21b9be41.svg";